import { Component } from '@verndale/core';
import axios from 'axios';
import CartCounter from './CartCounter';

class Cart extends Component {
  setupDefaults() {
    this.dom = {
      buttonsContainer: this.el.querySelector('.cart__buttons'),
      mainContainer: this.el.querySelector('.cart__content'),
      emptyCart: this.el.querySelector('.cart__content-empty'),
      itemsList: this.el.querySelector('.cart__items'),
      cartDescription: this.el.querySelector('.cart__description'),
      getProductsEndpoint: this.el.dataset.getProductsEndpoint,
      removeProductsEndpoint: this.el.dataset.removeProductsEndpoint,
      addProductsEndpoint: this.el.dataset.addProductsEndpoint,
      counter: document.querySelector('body'),
      cartContainerDesktop: document.querySelector('.cart__container'),
      cartBtnDesktop: document.querySelector(
        '.desktop-header__nav__utility-nav-item--cart'
      ),
      cartBtnMobile: document.querySelector(
        '.mobile-header__cart-button button'
      ),
      cartContainerMobile: document.querySelector('.cart__container'),
    };

    this.getProducts();

    window.addProduct = this.addProduct.bind(this);
    window.getProducts = this.getProducts.bind(this);
    window.removeProduct = this.setRemoveProduct.bind(this);
    this.counter = new CartCounter(this.dom.counter);
    this.mq = window.matchMedia('(max-width: 1024px)');
    this.resizeBasedOnSafari();
  }

  addListeners() {
    if (this.mq) {
      this.mq.addEventListener('change', this.resizeBasedOnSafari.bind(this));
    }
  }

  cleanCart() {
    this.dom.itemsList.innerHTML = '';
  }

  async addProduct(productId) {
    if (this.dom.addProductsEndpoint) {
      try {
        const { data } = await axios.post(this.dom.addProductsEndpoint, {
          id: productId,
        });
        if (data && data.d && data.d.code) {
          this.renderAlert(data.d.errorMessage);
        } else {
          this.counter.checkCartItems();
          if (window.innerWidth > 1024) {
            this.toggleCart(
              this.dom.cartBtnDesktop,
              this.dom.cartContainerDesktop
            );
          } else {
            this.toggleCart(
              this.dom.cartBtnMobile,
              this.dom.cartContainerMobile
            );
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.cleanCart();
        this.getProducts();
      }
    }
  }

  toggleCart(button, container) {
    window.scrollTo(0, 0, { behavior: 'smooth' });
    button.classList.toggle('is-active');

    if (container.hidden) {
      container.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    } else {
      container.setAttribute('hidden', true);
      document.body.style.overflow = 'auto';
    }
  }

  renderAlert(message) {
    const alert = `
    <dialog class='cart-alert' open>
      <div class='cart-alert__content'>
        <div class='cart-alert__icon'>
          <svg class='cart-alert__icon__svg'>
            <use xlink:href='#cart-alert-icon' />
          </svg>
        </div>
        <div class='cart-alert__message'>
          <span class='cart-alert__message__text'>
            ${message}
          </span>
        </div>
        <button class='cart-alert__close-button'>
          <svg class='cart-alert__icon-close'>
            <use xlink:href='#remove-icon-cart' />
          </svg>
        </button>
      </div>
    </dialog>
    `;

    window.scrollTo(0, 0, { behavior: 'smooth' });
    document.body.insertAdjacentHTML('beforeend', alert);
    const alertCloseButton = document.querySelector(
      '.cart-alert__close-button'
    );
    const alertOverlay = document.querySelector('.cart-alert__close-button');
    alertCloseButton.addEventListener('click', this.removeAlert.bind(this));
    alertOverlay.addEventListener('click', this.removeAlert.bind(this));
  }

  removeAlert() {
    const alert = document.querySelector('.cart-alert');
    if (alert) {
      alert.remove();
    }
  }

  async getProducts() {
    if (this.dom.getProductsEndpoint) {
      try {
        const { data } = await axios.post(this.dom.getProductsEndpoint, {});
        if (data && data.d && data.d.Products && data.d.Products.length > 0) {
          this.dom.emptyCart.setAttribute('hidden', true);
          this.dom.itemsList.removeAttribute('hidden');
          this.dom.mainContainer.removeAttribute('hidden');
          this.dom.cartDescription.innerHtml = data.d.CartDescription;
          this.cleanCart();
          this.renderProducts(data.d.Products);
          this.addRemoveProductListeners();
          this.counter.checkCartItems();
        } else {
          this.dom.mainContainer.setAttribute('hidden', true);
          this.dom.itemsList.setAttribute('hidden', true);
          this.dom.emptyCart.removeAttribute('hidden');
          this.counter.checkCartItems(true);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  addRemoveProductListeners() {
    const removeProductBtns = this.el.querySelectorAll(
      '.cart__item__remove-button'
    );
    removeProductBtns.forEach((btn) => {
      btn.addEventListener('click', this.removeProduct.bind(this));
    });
  }

  removeProduct(e) {
    const productId = e.target.closest('.cart__item').dataset.productId;
    this.setRemoveProduct(productId);
    e.target.closest('.cart__item').remove();

    const cartItems = this.el.querySelectorAll('.cart__item');
    if (cartItems.length === 0) {
      this.dom.mainContainer.setAttribute('hidden', true);
      this.dom.itemsList.setAttribute('hidden', true);
      this.dom.emptyCart.removeAttribute('hidden');
    }
  }

  async setRemoveProduct(productId) {
    if (this.dom.removeProductsEndpoint) {
      try {
        const { data } = await axios.post(this.dom.removeProductsEndpoint, {
          id: productId,
        });
        if (data) {
          this.getProducts();
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  renderProducts(products) {
    products.forEach((product) => {
      const item = this.createProductItem(product);
      this.dom.itemsList.insertAdjacentHTML('beforeend', item);
    });
  }

  createProductItem(product) {
    return `
    <li class='cart__item' data-product-id='${product.Id}'>
      <div class='cart__item__image'>
        <img
          src='${product.ImageUrl}'
          alt='${product.ImageDescription}'
        />
      </div>
      <div class='cart__item__content'>
        <a href='${product.Url}' class='cart__item__title'>
        ${product.Title}
        </a>
        <div class='cart__item__description'>
          <div class='cart-item-attribute'>
            ${product.Size}
          </div>
          ${product.ColorName && product.ColorValue ? `<div class='cart-item-attribute'>
            <span>Color:</span>
            <span class='item-color item-color--${product.ColorValue}'></span> ${product.ColorName}
          </div>` : ''}
          }
        </div>
      </div>
      <button class='cart__item__remove-button'>
        <svg class='cart__menu-button__icon-open'>
          <use xlink:href='#remove-icon-cart' />
        </svg>
      </button>
    </li>
    `;
  }

  resizeBasedOnSafari() {
    if (this.mq.matches) {
      const isSafari = /^((?!chrome|android).)*safari/i.test(
        navigator.userAgent
      );

      if (isSafari) {
        console.log('Safari detected');

        this.dom.buttonsContainer.style.paddingBlockEnd = '10vh';
        console.log(this.dom.buttonsContainer);
      }
    }
  }
}

export default Cart;
